module.exports = __webpack_public_path__ + "static/media/shree-logo.5724e50d.png";